import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { getLearningMode, setLearningMode } from "features/classroom/state";
import { getLearningModeFromParams } from "features/classroom/utils/withLearningModeQueryParams";

export default function useSetLearningMode() {
  const dispatch = useDispatch();
  const { search } = useLocation();

  const modeFromParams = getLearningModeFromParams(search);
  const modeFromState = useSelector(getLearningMode);

  useEffect(() => {
    if (modeFromParams && modeFromParams !== modeFromState) {
      dispatch(setLearningMode(modeFromParams));
    }
  }, [modeFromParams, dispatch, modeFromState]);
}
